import classNames from "classnames";
import { ClassNamesConfig } from "react-select";
import ButtonPopover from "ui/atoms/ButtonPopover/ButtonPopover";
import capitalize from "util/capitalize";
import { VocalRegister } from "./constants/vocalRegister";

const vocalRegisters: {
  [registern in VocalRegister]: { label: string; value: VocalRegister };
} = {
  [VocalRegister.Full]: { label: "Full Range", value: VocalRegister.Full },
  [VocalRegister.Chest]: { label: "Chest Voice", value: VocalRegister.Chest },
  [VocalRegister.Break]: { label: "The Break", value: VocalRegister.Break },
  [VocalRegister.Head]: { label: "Head Voice", value: VocalRegister.Head },
};

interface Props {
  value: VocalRegister;
  onChange: (value: VocalRegister) => void;
}

export default function VocalRegisterSelect({ value, onChange }: Props) {
  const selected = vocalRegisters[value];

  return (
    <ButtonPopover
      buttonProps={{
        theme: "default",
        children: capitalize(selected.value),
        size: "large",
      }}
    >
      <ul className={"px-3 py-3 text-sm text-white"}>
        {Object.values(vocalRegisters).map((register) => (
          <li key={register.value}>
            <div className="flex items-center p-2 rounded hover:bg-gray-800 text-white">
              <input
                id={`checkbox-item-${register.value}`}
                type="checkbox"
                checked={register.value === selected.value}
                onChange={() => onChange(register.value)}
                className="w-4 h-4 accent-purple-500 bg-gray-100 border-gray-300 cursor-pointer rounded"
              />

              <label
                htmlFor={`checkbox-item-${register.value}`}
                className="w-full ms-2 text-sm font-medium rounded cursor-pointer"
              >
                {register.label}
              </label>
            </div>
          </li>
        ))}
      </ul>
    </ButtonPopover>
  );
}

const classNamesConfig: ClassNamesConfig<{ value: VocalRegister }> = {
  control: ({}) =>
    classNames(
      "!bg-black !text-white !outline-none !border-white !text-xs !h-[53px]"
    ),

  singleValue: () => "!text-white",

  menu: (a) => "!bg-black hover:!bg-black !border-white !text-white !border",

  option: ({ isDisabled, isFocused, isSelected }) =>
    classNames(
      "!cursor-pointer !text-xs",
      isSelected && "!bg-purple-500",
      !isSelected && isFocused && "!bg-white !text-black",
      !isDisabled && isSelected && "active:!bg-white active:!text-black",
      !isDisabled && !isSelected && "active:!bg-purple-500"
    ),
};
